export { default as NewVolumeTypeToggle } from './NewVolumeTypeToggle';
